import { useState } from 'react';
import { Button, Offcanvas, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import languageIcon from '../../../assets/icons/language-icon.svg';
import './header.css';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Hospital Partners', path: '/hospitals' },
  { label: 'Medical Board', path: '/medical-board' },
  { label: 'News & Articles', path: '/news-articles' },
  { label: 'Contact Us', path: '/contact' },
];

const moreLinks = [
  { label: 'Case Studies', path: '/case-studies' },
  { label: 'CME', path: '/cme' },
  { label: 'Live Sessions', path: '/live-sessions' },
  { label: 'International Collaborations', path: '/international-collaborations' },
  { label: 'International Doctor Collaborations', path: '/international-doctor-collaborations' },
];

export const Header = () => {
  const [show, setShow] = useState(false);

  return (
    <header className="site-header">
      <div className="header-inner">

        {/* 1. Logo */}
        <div className="header-logo-wrap">
          <a href="/">
            <img src={logo} alt="Bizaario Care" className="header-logo" />
          </a>
        </div>

        {/* 2. Nav links — desktop only */}
        <div className="header-nav-wrap">
          <nav className="header-nav">
            {navLinks.map((link) => (
              <Link key={link.label} to={link.path} className="header-nav-link">
                {link.label}
              </Link>
            ))}
            {/* More dropdown */}
            <div className="header-more-wrap">
              <button className="header-nav-link header-more-btn">
                More
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="header-more-chevron">
                  <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <ul className="header-more-dropdown">
                {moreLinks.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="header-more-option">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>

        {/* 3. Actions — desktop only */}
        <div className="header-actions-wrap">
          <HeaderActions />
        </div>

        {/* Hamburger — mobile only */}
        <button
          className="header-hamburger d-lg-none"
          onClick={() => setShow(true)}
          aria-label="Open menu"
        >
          <span /><span /><span />
        </button>

      </div>

      {/* Offcanvas — mobile */}
      <Offcanvas show={show} onHide={() => setShow(false)} placement="end" className="header-offcanvas">
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title>
            <img src={logo} alt="Bizaario Care" className="header-logo" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column">
          <Nav className="flex-column mb-4">
            {navLinks.map((link) => (
              <Nav.Link
                key={link.label}
                as={Link}
                to={link.path}
                className="header-nav-link py-3 border-bottom"
                onClick={() => setShow(false)}
              >
                {link.label}
              </Nav.Link>
            ))}
            {moreLinks.map((link) => (
              <Nav.Link
                key={link.label}
                as={Link}
                to={link.path}
                className="header-nav-link py-3 border-bottom"
                onClick={() => setShow(false)}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>
          <HeaderActions vertical />
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
};

const LANGUAGES = ['English', 'Hindi', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Bengali'];

const HeaderActions = ({ vertical = false }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('English');

  return (
    <div className={`header-actions ${vertical ? 'header-actions--vertical' : ''}`}>
      <div
        className="header-lang-wrap"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <button className={`header-lang-btn${open ? ' header-lang-btn--open' : ''}`}>
          <img src={languageIcon} alt="language" className="header-lang-icon" />
          <span>{selected}</span>
          <svg
            width="12" height="12" viewBox="0 0 12 12" fill="none"
            className={`header-lang-chevron${open ? ' header-lang-chevron--up' : ''}`}
          >
            <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        {open && (
          <ul className="header-lang-dropdown">
            {LANGUAGES.map((lang) => (
              <li key={lang}>
                <button
                  className={`header-lang-option${lang === selected ? ' header-lang-option--active' : ''}`}
                  onClick={() => { setSelected(lang); setOpen(false); }}
                >
                  {lang}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <Button variant="outline-secondary" className="header-btn-login" as={Link} to="/login">Login</Button>
      <Button className="header-btn-signup" as={Link} to="/signup">Sign Up</Button>
    </div>
  );
};
